export default {
  init() {
    const LINES = 3;

    const setupPresentation = (wrapper) => {
      if (wrapper.dataset.presentationInit === "1") return;

      const content = wrapper.querySelector(".book-full__presentation-content");
      const toggle = wrapper.querySelector(".book-full__presentation-more");
      const label = wrapper.querySelector(
        ".book-full__presentation-more-label",
      );

      if (!content || !toggle || !label) return;

      wrapper.dataset.presentationInit = "1";

      toggle.setAttribute("role", "button");
      toggle.setAttribute("tabindex", "0");

      const setToggleVisible = (visible) => {
        toggle.style.display = visible ? "" : "none";
      };

      const getLineHeightPx = () => {
        const lh = window.getComputedStyle(content).lineHeight;
        if (lh.endsWith("px")) return parseFloat(lh);

        const fontSize = parseFloat(window.getComputedStyle(content).fontSize);
        if (Number.isFinite(fontSize)) return fontSize * 1.25;

        return 0;
      };

      const recompute = () => {
        // If user expanded the text, don't auto-reset on ResizeObserver ticks.
        if (wrapper.classList.contains("is-expanded")) {
          setToggleVisible(true);
          return;
        }

        wrapper.classList.remove("is-clamped");
        setToggleVisible(false);

        const lineHeight = getLineHeightPx();
        if (!lineHeight) return;

        const maxHeight = Math.ceil(lineHeight * LINES);
        const overflows = content.scrollHeight > maxHeight + 1;

        if (overflows) {
          wrapper.classList.add("is-clamped");
          label.textContent = "Lire plus";
          setToggleVisible(true);
        }
      };

      const toggleExpanded = () => {
        const expanded = wrapper.classList.toggle("is-expanded");
        wrapper.classList.toggle("is-clamped", !expanded);
        label.textContent = expanded ? "Réduire" : "Lire plus";
      };

      toggle.addEventListener("click", toggleExpanded);
      toggle.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleExpanded();
        }
      });

      recompute();

      if ("ResizeObserver" in window) {
        const ro = new ResizeObserver(() => recompute());
        ro.observe(content);
      } else {
        window.addEventListener("resize", recompute);
      }
    };

    const run = () => {
      const presentations = Array.from(
        document.querySelectorAll(".book-full__presentation"),
      );
      presentations.forEach(setupPresentation);
      return presentations.length > 0;
    };

    // Try immediately (normal full page load).
    if (run()) return;

    // If DOM isn't ready yet, retry once it's ready.
    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        () => {
          if (run()) return;
        },
        { once: true },
      );
    }

    // BigPipe / late-inserted markup: observe until found.
    if (document.body && "MutationObserver" in window) {
      const mo = new MutationObserver(() => {
        if (run()) {
          mo.disconnect();
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  },
};
